import { Component, Input, OnInit } from '@angular/core';
import { ToastController,ModalController } from '@ionic/angular';

import { Sale } from '../../../models/sale/sale.model';
import { Stylist } from '../../../models/stylist/stylist.model';
import { Payment } from '../../../models/payment/payment.model';
import { CardTerminalService, CardTerminalResponse } from '../../../services/card-terminal.service';
//import { loadStripeTerminal } from "@stripe/terminal-js";
import { switchMap } from 'rxjs/operators';
import { ToastService } from '../../../utilities/toast.service';

export interface TerminalConnectionPageCallback extends CardTerminalResponse {
  tips: number;
  tipsForStylist: Stylist;
}
@Component({
  selector: 'app-terminal-connection',
  templateUrl: './terminal-connection.page.html',
  styleUrls: ['./terminal-connection.page.scss'],
})
export class TerminalConnectionPage implements OnInit {

  @Input() sale: Sale;

  @Input() payment: Payment;

  public isConnecting: boolean;

  public anErrorOccurred: boolean;

  @Input() paymentFromTerminalSuccess: boolean;

  public responseFromTerminal: TerminalConnectionPageCallback;

  public sessionKey: string;

  public tipsReceived: number;

  public tipsForStylist: Stylist;

  public paymentReceived: number;

  constructor (
      //private navParams: NavParams,
      private cardTerminalService: CardTerminalService,
      private toastController: ToastController,
      //private viewCtrl: ViewController
      private toastService: ToastService,
      private modalController: ModalController
      ) {
    //this.sale = this.navParams.get('sale');
    //this.payment = this.navParams.get('payment');
    // this.paymentFromTerminalSuccess = true;
  }

  public ngOnInit () {
   this.connect();
  }

  public onDismiss () {

    if (this.responseFromTerminal) {
      if (this.tipsReceived > 0) {
        this.responseFromTerminal.tipsForStylist = this.tipsForStylist;
      }
    }

    this.modalController.dismiss(this.responseFromTerminal);
  }

  public onStylistPickerInit (initResponse: {success: boolean, stylist: Stylist}) {

    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {

    }
  }

  public onStylistSelect (stylist: Stylist) {
    this.tipsForStylist = stylist;
  }

  public connect () {
    this.isConnecting = true;
    this.anErrorOccurred = false;
    this.cardTerminalService.connect()
      .pipe(
        switchMap((response: string) => {
          this.sessionKey = response;
          this.isConnecting = false;
          this.anErrorOccurred = false;
          return this.cardTerminalService.processPayment({ amount: this.payment.amount, sessionKey: this.sessionKey});
        })
      )
      .subscribe((response) => {
        if (response.respstat === 'A') {

          if (this.payment.amount === response.payment) {
           this.modalController.dismiss(response);
          } else if (this.payment.amount < response.payment) {
            this.paymentFromTerminalSuccess = true;
            this.responseFromTerminal = {
              ...response,
              tips: response.calculatedTipValue,
              tipsForStylist: undefined
            }
            this.tipsReceived = response.calculatedTipValue;
            this.paymentReceived = response.payment;
          } else {
            this.modalController.dismiss();
          }

        } else {
          this.modalController.dismiss();
        }

      },
      async (err) => {

        if (err.err_msg && err.err_msg.errorCode === 8) {
          this.toastService.presentSimpleToast(`The transaction was cancelled by the user.`, 3000);
          const toast = await this.toastController.create({ message: 'The transaction was cancelled by the user.', duration: 2000, position: 'middle' })
          toast.present();
          this.modalController.dismiss();
          return;
        }

        this.anErrorOccurred = true;
        this.isConnecting = false;
      });
  }

  public disconnect () {
    this.cardTerminalService.disconnect(this.sessionKey)
      .subscribe({next:() => {
      },
      error: (e) => {
      }
    });

    this.modalController.dismiss();
  }
  

}
